module.exports = __webpack_public_path__ + "img/ed002-regpen.96d0de95.png";